const bytesToHex = (bytes: Uint8Array) =>
  Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");

export const normalizeEmail = (email: string) => email.trim().toLowerCase();

export async function gravatarHash(email: string): Promise<string> {
  const encoded = new TextEncoder().encode(normalizeEmail(email));
  return bytesToHex(new Uint8Array(await crypto.subtle.digest("SHA-256", encoded)));
}

export const gravatarUrl = (hash: string, size = 160) =>
  `https://gravatar.com/avatar/${hash}?s=${size}&d=retro&r=g`;
